import { api } from "@/lib/api";

export type NdAgentInfo = {
  id: string;
  name: string;
  role: string;
  title: string | null;
  icon: string | null;
  status: string;
  capabilities: string | null;
  personaKey: string;
  personaVersion: string;
  personaPrompt: string | null;
  instructionsFilePath: string | null;
  defaultModel: string;
};

export const ndAgentsApi = {
  list: (companyId: string) =>
    api.get<NdAgentInfo[]>(`/companies/${companyId}/nd-agents`),
};
